<template>
  <v-layout
    column
    align-center
    justify-center
    :class="classes"
    :style="`--p-height: ${height}px`"
  >
    <v-progress-circular
      indeterminate
      color="secondary"
      v-bind:width="2"
      v-bind:size="210"
    >
      <img
        src="../../../static/Icononaranjo.png"
        alt="logo"
        width="auto"
        height="100px"
      />
    </v-progress-circular>
  </v-layout>
</template>

<script>
export default {
  props: {
    height: {
      type: Number,
      default: 215
    },
    classes: {
      type: String,
      default: "base-loader"
    }
  }
};
</script>

<style>
.base-loader {
  height: calc(100vh - var(--p-height));
}
</style>



// WEBPACK FOOTER //
// src/components/base/Loader.vue